import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ResourcesEditControllerModule } from './controllers/ResourcesEditController';

export const ResourcesEditView = angular
  .module('acme.view.application.resources.edit', [uiRouter, 'ui.bootstrap', ResourcesEditControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.resources.edit',
      url: '/edit/:id',
      views: {
        'subview-main': {
          controller: 'ResourcesEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Resource Template',
      },
    });
  }).name;
